import { useState } from 'react';
import { InputField } from '@/kit/FormField';
import { toAmount } from '@/core/models/partner-allocation.models';

/** Angular's input shows a null/undefined model as an empty box. */
const display = (value: number | null | undefined) => (value === null || value === undefined ? '' : String(value));

interface AmountInputProps {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  fieldClassName: string;
}

/**
 * The grid's numeric text input: Angular's one-way `[ngModel]="value"` with `(ngModelChange)="onAmountChange(...)"`.
 * What the user types is kept as typed (`1.` stays `1.`) and only stored as `toAmount(text)`; the text is rewritten
 * only when the stored number itself changes (so `abc` on a 5 becomes `0`, but on a 0 it stays `abc`).
 */
export function AmountInput({ value, onChange, disabled, fieldClassName }: AmountInputProps) {
  const [text, setText] = useState(display(value));
  const [seen, setSeen] = useState(value);
  if (!Object.is(value, seen)) {
    setSeen(value);
    setText(display(value));
  }

  return (
    <InputField
      fieldClassName={fieldClassName}
      autoComplete="off"
      inputMode="decimal"
      disabled={disabled}
      value={text}
      onChange={(event) => {
        setText(event.target.value);
        onChange(toAmount(event.target.value));
      }}
    />
  );
}
